import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Header from "../Header/Header";
import "./style.css";

const Layout = (props) => {
  const [sidebar, setSidebar] = useState(false);
  const [mobile, setMobile] = useState(false);
  
  const showSidebar = () => setSidebar(!sidebar);

  useEffect(() => {
    const checkMobile = () => {
      window.innerWidth < 992 ? setMobile(true) : setMobile(false);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleContentClick = () => {
    if (mobile) {
      setSidebar(false);
    }
  }

  return (
    <div className="layout">
      <div
        style={{ width: `${sidebar ? "6%" : ""}` }}
        className={`left-sec ${
          sidebar
            ? "nav-menu active"
            : "nav-menu d-flex justify-content-center"
        }`}
      >
        <Sidebar
          page={props.page}
          isActive={sidebar ? "active" : ""}
          showSidebar={showSidebar}
        />
      </div>
      <div className={`right-sec ${sidebar ? `sec-size` : ""}`}>
        <Header title={props.title} showSidebar={showSidebar} />
        <div className="layout-content py-1" onClick={handleContentClick}>
          {props.children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
